import MainApi from './MainApi';

const api = new MainApi({
  baseURL: process.env.REACT_APP_CORE_URL || '',
});

api.axios.defaults.withCredentials = true;

export default api;
